import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import { SmartScheduleOnboardingImage } from './SmartScheduleOnboardingImage';

import * as styles from './StartScheduling.module.less';

export const StartScheduling = ({ onNext }: { onNext: () => void }) => {
  return (
    <div className={styles.container}>
      <h2>
        <FormattedMessage
          id="templates.smart_schedule.onboarding.start-heading"
          defaultMessage="Trello automatically identifies and schedules focus time for your To-Dos"
          description="Heading on the first Smart Schedule onboarding page"
        />
      </h2>
      <Button appearance="primary" onClick={onNext}>
        <FormattedMessage
          id="templates.smart_schedule.onboarding.start-scheduling-cta"
          defaultMessage="Start scheduling my focus time"
          description="Primary call to action to begin scheduling focus time"
        />
      </Button>
      <SmartScheduleOnboardingImage />
    </div>
  );
};
